import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BarList from './BarList';

import transformArrayToBarChartObject from '../utils/transformArrayToBarChartObject';

const ChartWrapper = styled.div`
  height: ${props => props.theme.components.chartHeight};
  display: flex;
`;

function BeliefsVisualisation({ data }) {
  const transformedData = transformArrayToBarChartObject(
    data?.beliefs?.filter(belief => belief.type === 'LIMITING')?.slice(0, 5),
    null,
    null,
    'title',
    false,
  );

  return (
    <ChartWrapper>
      <BarList data={transformedData} />
    </ChartWrapper>
  );
}

BeliefsVisualisation.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
export default BeliefsVisualisation;
